import React from "react";
import { LeadRequirement } from "../../../core/api/models/requirement";

const publicUrl = window.location.origin; // process.env.PUBLIC_URL;
const backgroundBgWithShadow = `${publicUrl}/background-bg-with-shadow.jpg`;
const requirementBanner = `${publicUrl}/requirment-banner.png`;
const dottedBorder = `${publicUrl}/dotted-border.png`;
const tickIcon = `${publicUrl}/tick-icon.png`;

interface ProposalRequirementBriefProps {
    requirementData: LeadRequirement | undefined;
}

export const ProposalRequirementBrief: React.FC<ProposalRequirementBriefProps> = ({ requirementData }) => {
    return (
        <>
            {requirementData?.coreRequirements?.length &&
                requirementData?.coreRequirementParameters?.length ? (
                <table className="table-outer-area page-break"
                    style={{
                        // backgroundImage: `url(${require("../../../assets/images/proposal/background-bg-with-shadow.png")})`,
                        backgroundImage: `url(${backgroundBgWithShadow})`,
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "bottom",
                        backgroundSize: "cover",
                        marginTop: "15px",
                        minHeight: "794px",
                    }}
                    width="100%"
                    cellPadding="50"
                    cellSpacing="0"
                >
                    <tbody>
                        <tr>
                            <td
                                width="30%"
                                style={{
                                    // backgroundImage: `url(${require("../../../assets/images/requirment-banner.png")})`,
                                    backgroundImage: `url(${requirementBanner})`,
                                    backgroundPosition: "right",
                                    backgroundSize: "cover",
                                    backgroundRepeat: "no-repeat",
                                    WebkitBackgroundSize: "cover",
                                    fontSize: "30px",
                                    color: "#fff",
                                    fontWeight: 700,
                                    textTransform: "uppercase",
                                }}
                            >
                                Requirement <br />
                                Brief:
                                <hr
                                    style={{
                                        height: "3px",
                                        backgroundColor: "#C39765",
                                        border: "0",
                                    }}
                                ></hr>
                            </td>

                            <td width="70%" style={{ paddingLeft: "100px" }}>
                                <table width="100%" cellPadding="0" cellSpacing="0">
                                    <tbody>
                                        <tr>
                                            <td>
                                                <table width={460} style={{ width: "460px" }}>
                                                    <tbody>
                                                        <tr>
                                                            <td height="65"></td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <span
                                                                    style={{
                                                                        fontSize: "22px",
                                                                        color: "#8FA9D4",
                                                                        fontWeight: 700,
                                                                    }}
                                                                >
                                                                    <u> CORE REQUIREMENT</u>{" : "}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td height="22"></td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <ul
                                                                    style={{
                                                                        listStyleType: "none",
                                                                        padding: "0",
                                                                    }}
                                                                >
                                                                    {requirementData?.coreRequirements?.map(
                                                                        (value, index) => (
                                                                            <li
                                                                                key={index}
                                                                                style={{
                                                                                    fontSize: "17px",
                                                                                    color: "#5E5E5E",
                                                                                    fontWeight: 400,
                                                                                    padding: "0 10px 14px",
                                                                                    backgroundRepeat: "no-repeat",
                                                                                    marginBottom: "7px",
                                                                                    backgroundSize: "contain",
                                                                                    backgroundPosition:
                                                                                        "0px calc(100% - 8px)",
                                                                                    // backgroundImage: `url(${require("../../../assets/images/dotted-border.png")})`,
                                                                                    backgroundImage: `url(${dottedBorder})`,
                                                                                }}
                                                                            >
                                                                                {value}
                                                                            </li>
                                                                        )
                                                                    )}
                                                                </ul>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td height="20"></td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <span
                                                    style={{
                                                        fontSize: "22px",
                                                        color: "#001C76",
                                                        fontWeight: 700,
                                                    }}
                                                >
                                                    <u> REQUIREMENT PARAMETERS</u>{" : "}
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td height="27"></td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <ul style={{ listStyleType: "none", padding: "0" }}>
                                                    {requirementData?.coreRequirementParameters?.map(
                                                        (value) => (
                                                            <li
                                                                style={{
                                                                    fontSize: "17px",
                                                                    color: "#5E5E5E",
                                                                    fontWeight: 400,
                                                                    padding: "0 0px 12px",
                                                                    backgroundRepeat: "no-repeat",
                                                                    marginBottom: "7px",
                                                                    backgroundSize: "cover",
                                                                    backgroundPosition:
                                                                        "0px calc(100% - 8px)",
                                                                    // backgroundImage: `url(${require("../../../assets/images/dotted-border.png")})`,
                                                                }}
                                                            >
                                                                <img
                                                                    width="29"
                                                                    height="28px"
                                                                    src={tickIcon}
                                                                    alt="tick"
                                                                    style={{ marginRight: '20px' }}
                                                                />
                                                                {value}
                                                            </li>
                                                        )
                                                    )}
                                                </ul>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td height="35"></td>
                                        </tr>
                                        <tr>
                                            {" "}
                                            <td
                                                height="3"
                                                style={{ backgroundColor: "#C39765" }}
                                            ></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>
            ) : null}
        </>
    );
}
